import script from "./PatientsListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientsListPage.vue?vue&type=script&setup=true&lang=js"

import "./PatientsListPage.vue?vue&type=style&index=0&id=34cb667a&lang=scss"

const __exports__ = script;

export default __exports__